import Vue from 'vue';

const success = (response, context) => {
    context.datasetsData = [];
    context.datasetsLabels = [];
    context.user = response.user;
    context.channels = response.channels;
    context.nightsSold = response.nightsSold;
    context.nightsToSell = response.nightsToSell;
    context.occupancy = response.occupancy;
    context.avgGuestCount = response.avgGuestCount;
    context.rentalsCount = response.rentalsCount;
    context.totalIncome = response.totalIncome;
    context.totalIncomePerMonth = response.totalIncomePerMonth;
    context.analyticTableData = response.analyticTableData;
    context.avgNightBooked = response.avgNightBooked;
    context.avgPayout = response.avgPayout;
    context.totalNightsSold = response.totalNightsSold;
    context.totalNightsToSell = response.totalNightsToSell;
    context.totalOccupancy = response.totalOccupancy;
    context.totalCityTaxes = response.totalCityTaxes;
    context.totalCommissions = response.totalCommissions;
    context.totalNetIncome = response.totalNetIncome;
    context.occupancyWithoutBlockedDates = response.occupancyWithoutBlockedDates;
    context.channelsIncomePerMonth = response.channelIncomePerMonth;
    context.totalCommissionPerMonth = response.currentMonthData.commission;
    context.totalNetIncomePerMonth = response.currentMonthData.netIncome;
    context.totalCityTaxesPerMonth = response.currentMonthData.cityTaxes;
    context.totalCleaningFeesPerMonth = response.currentMonthData.cleaningFees;
    context.nbrCheckingCheckout = response.currentMonthData.nbrCheckingCheckout;

    for(let key in context.channels) {
      if (context.channels.hasOwnProperty(key)) {
        context.datasetsData.push(context.channels[key]);
        context.datasetsLabels.push(key + ' ' + ((context.channels[key] / context.nightsSold) * 100).toFixed(2) + '% ');
      }
    }

    context.channelsIncomeDatasetsData = [];
    context.channelsIncomeDatasetsLabels = [];

    for (let key in context.channelsIncomePerMonth) {
        if (context.channelsIncomePerMonth.hasOwnProperty(key)) {
          if (context.channelsIncomePerMonth[key] > 0) {
            context.channelsIncomeDatasetsData.push(context.channelsIncomePerMonth[key]);
            context.channelsIncomeDatasetsLabels.push(`${key} ${((context.channelsIncomePerMonth[key] / context.totalIncomePerMonth) * 100).toFixed(2)}% `);
          }
        }
      }

    if(context.checkedRentals && context.getCheckedRentalIds(context.checkedRentals).length === 0) {
        let monthNumb = context.month - 1;
        context.nightsSold = context.analyticTableData[monthNumb].nightsSold;
        context.nightsToSell = context.analyticTableData[monthNumb].nightsToSell;
        context.occupancy = context.analyticTableData[monthNumb].occupancy;
        context.totalIncomePerMonth = context.analyticTableData[monthNumb].income;
    }

    context.occupancyData = {
      label: [],
      value: []
    };

    context.incomeData = {
      label: [],
      value: []
    };

    for (let i = 0; i < context.analyticTableData.length; i++){
        context.occupancyData.label.push(context.$t('months')[i]);
        context.occupancyData.value.push(context.analyticTableData[i].occupancy);
        context.incomeData.label.push(context.$t('months')[i]);
        context.incomeData.value.push(context.analyticTableData[i].income);
    }

    context.generalLoading = false;
};

const failed = (error, context) => {
    context.generalLoading = false;
};

export default (url, context) => {
  return Vue.$http.get(url)
    .then((response) => {
      if (response && response.status === 200) {
        success(response.data, context);
      } else {
        failed();
      }
    })
    .catch((error) => {
      failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/analytics/getGeneralTab.js